import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import axios from "axios";

function InputCompany() {
  const navigate = useNavigate();
  const [internalData, setInternalData] = useState(null);
  const [error, setError] = useState("");
  const [registerDate, setRegisterDate] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyPhone, setCompanyPhone] = useState("");
  const [companyMobilePhone, setCompanyMobilePhone] = useState("");
  const [salesList, setSalesList] = useState([]);
  const [selectedSales, setSelectedSales] = useState('');

  const [values, setValues] = useState({
    quotationPriceUsd: "",
    quotationPriceIdr: "",
    salesOrderPriceUsd: "",
    salesOrderPriceIdr: "",
  });
  const [displayValues, setDisplayValues] = useState({
    quotationPriceUsd: "",
    quotationPriceIdr: "",
    salesOrderPriceUsd: "",
    salesOrderPriceIdr: "",
  });

  const [quotationMsaDate, setQuotationMsaDate] = useState(""); 
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openInputSuccess, setOpenInputSuccess] = useState(false);
  const [openInputFail, setOpenInputFail] = useState(false);
  
  const resource = 'input-company';

  function formatNominal(nominal) {
    if(nominal.charAt(nominal.length - 1) == ","){
      nominal = nominal.slice(0, -1) + ",0";
    } 

    // Konversi ke string untuk pengecekan desimal
    let strNominal = nominal.toString();
    
    // Pisahkan bagian desimal jika ada
    let [integerPart, decimalPart] = strNominal.split(',');
    
    // Format bagian integer secara manual
    let formattedInteger = '';
    let counter = 0;
    for (let i = integerPart.length - 1; i >= 0; i--) {
        formattedInteger = integerPart[i] + formattedInteger;
        counter++;
        if (counter % 3 === 0 && i !== 0) {
            formattedInteger = '.' + formattedInteger;
        }
    }
    
    // Gabungkan kembali dengan bagian desimal jika ada
    let result = decimalPart ? formattedInteger + ',' + decimalPart : formattedInteger;

    if (result .includes(",0")){
      result = result .replace(",0", ",");
    }
    return result
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("id-ID").format(value);
  };

  const handleCurrencyChange = (key) => (e) => {
    let rawValue = e.target.value.replace(/[^0-9,]/g, "");
    if (rawValue.includes(",")) {
      setDisplayValues((prev) => ({ ...prev, [key]: formatNominal(rawValue) }));
      setValues((prev) => ({ ...prev, [key]: parseFloat(rawValue.replace(",", ".")) }));
    } else {
      const numericValue = parseInt(rawValue, 10) || "";
      if (rawValue === "0" ){
        setDisplayValues((prev) => ({ ...prev, [key]: rawValue }));
        setValues((prev) => ({ ...prev, [key]: rawValue }));
      }else{
        setDisplayValues((prev) => ({ ...prev, [key]: numericValue ? formatCurrency(numericValue) : "" }));
        setValues((prev) => ({ ...prev, [key]: numericValue }));
      }
    }
  };

  useEffect(() => {
    const storedToken = localStorage.getItem("token");

    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();
  }, []);

  useEffect(() => {
    // Retrieve the token from local storage
    const storedToken = localStorage.getItem("token");

    // Fetch internal data using the token
    const fetchInternalData = async () => {
      try {
        const response = await fetch(
          `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/find-by-token?token=${storedToken}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
          }
        );

        const data = await response.json();
        if (!response.ok) {
          setError(data.message || "Failed to fetch internal data");
          throw new Error(data.message || "Failed to fetch internal data");
        }

        setInternalData(data[0]);
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    fetchInternalData();
  }, []);

  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0];
    setRegisterDate(currentDate);
  }, []);

  function getDateTimeInUserTimeZone(registerDate) {
    const userTimeZone = moment.tz.guess();
    // Get the current time in the user's local time zone
    const currentTime = moment.tz(userTimeZone).format("HH:mm:ss");
    // Combine the selected date with the current time
    const dateTimeInUserTimeZone = moment
      .tz(`${registerDate}T${currentTime}`, userTimeZone)
      .format("YYYY-MM-DDTHH:mm:ss");
    return dateTimeInUserTimeZone;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    
      let dateTimeInUserTimeZone = getDateTimeInUserTimeZone(registerDate);
      const formData = {
        internalEmail: internalData.xcp_internal_email,
        registerDate: dateTimeInUserTimeZone,
        companyName: companyName,
        companyAddress: companyAddress,
        companyPhone: companyPhone,
        companyMobilePhone: companyMobilePhone,
        companySalesPic: selectedSales,
        quotationMsaDate: quotationMsaDate
      };

      const combinedData = {
        ...formData,
        ...values
      };
      
      try {
        const response = await fetch(
          "https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/company/input-company",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
            body: JSON.stringify(combinedData),
          }
        );

        const data = await response.json();
        const responseBody = JSON.parse(data.body);
        if (!response.ok) {
          setError(data.message || "Failed to submit form");
          throw new Error(data.message || "Failed to submit form");
        }

        const { message } = responseBody;
        if (message == "success") {
          setOpenConfirm(false)
          setOpenInputSuccess(true)
        } else {
          setOpenConfirm(false)
          setOpenInputFail(true)
        }
      } catch (error) {
        console.error("Submission Error:", error.message);
        setError("Submission Error: " + error.message);
      }
  };

  const handleClose = () => {
    setOpenConfirm(false);
    setOpenInputFail(false)
  };

  const handleConfirmation = async (event) => {
    event.preventDefault();
    setOpenConfirm(true);
  };

  function inputSuccess(){
    navigate("/company-list")
  }

  useEffect(() => {
    loadSalesList();
  }, []);

const loadSalesList = async () => {
  //Role Sales
  const roleId = 2 ;
  const result = await axios.get(`https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/master/internal/find-by-role?roleId=${roleId}`, {
              headers: {
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            });
  const data = result.data;  
  setSalesList(data);
};

const handleSalesListChange = (event) => {
  setSelectedSales(event.target.value);
};

  return (
    <div className="container-order-input">
      <Dialog open={openConfirm}>
          <DialogTitle>{"Are you sure you want to input this company?"}</DialogTitle>
              <DialogContent>
                  <DialogContentText>
                      Clicking "Yes" will input this company.
                  </DialogContentText>
              </DialogContent>
          <DialogActions>
              <Button onClick={handleClose} color="primary">
                  No
              </Button>
              <Button onClick={handleSubmit} color="primary" autoFocus>
                  Yes
              </Button>
          </DialogActions>
        </Dialog> 
        <Dialog open={openInputSuccess}>
          <DialogTitle>{"Company Form submitted successfully"}</DialogTitle>
          <DialogActions>
            <Button onClick={inputSuccess} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
      </Dialog>
      <Dialog open={openInputFail}>
        <DialogTitle>{"Company Form submitted failed"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <h1>Cross Connect Company Form</h1>
      <form onSubmit={handleConfirmation}>
        <div className="order-information-order-input">
          <div className="title-order-input">
            <h6>Fullfill the company form as follows.</h6>
            {error && <p className="error-message">{error}</p>}
          </div>
        </div>
        <div className="box-two-part">
          <div className="requestor-information">
            <div className="textbox-gray">
              <label htmlFor="registerDate">Register Date</label>
              <input
                type="date"
                id="registerDate"
                value={registerDate}
                onChange={(e) => setRegisterDate(e.target.value)}
                required
                disabled
                style={{ paddingLeft: "5px" }}
              />
            </div>
            <div className="textbox">
              <label htmlFor="companyName">Company Name</label>
              <input
                type="text"
                placeholder="Company Name"
                onChange={(e) => setCompanyName(e.target.value)}
                required
                style={{ paddingLeft: "5px" }}
              />
            </div>
            <div className="textbox">
              <label htmlFor="officeAddress">Company Address</label>
              <textarea
                onChange={(e) => setCompanyAddress(e.target.value)}
                required
                style={{ paddingLeft: "5px" }}
              ></textarea>
            </div>
            <div className="textbox">
              <label htmlFor="officePhone">Company Phone</label>
              <input
                type="tel"
                id="companyPhone"
                name="companyPhone"
                placeholder="021xxx"
                pattern="0\d{6,}"
                onChange={(e) => setCompanyPhone(e.target.value)}
                required
                style={{ paddingLeft: "5px" }}
              />
            </div>
            <div className="textbox">
              <label htmlFor="officeMobilePhone">Company Mobile Phone</label>
              <input
                type="tel"
                id="companyMobilePhone"
                name="companyMobilePhone"
                placeholder="085xxx"
                pattern="08\d{8,}"
                onChange={(e) => setCompanyMobilePhone(e.target.value)}
                style={{ paddingLeft: "5px" }}
              />
            </div>
            <div className="textbox">
                <label htmlFor="comboBox">Company Sales PIC</label>
                <select 
                id="comboBox" 
                name="options" 
                value={selectedSales} 
                onChange={handleSalesListChange}
                required
                >
                    <option value ="" disabled>Select Company Sales PIC</option>
                    {salesList.map((item) => (
                    <option key={item.xcp_internal_id} value={item.xcp_internal_id}>
                        {item.xcp_internal_name}
                    </option>
                    ))}
                </select>                         
            </div> 
            <>
              {[
                { key: "salesOrderPriceUsd", label: "Sales Order Price (USD)" },
                { key: "salesOrderPriceIdr", label: "Sales Order Price (IDR)" },
                { key: "quotationPriceUsd", label: "Quotation Price (USD)" },
                { key: "quotationPriceIdr", label: "Quotation Price (IDR)" },            
              ].map(({ key, label }) => (
                <div className="textbox" key={key}>
                  <label htmlFor={key}>{label}</label>
                  <input
                    type="text" 
                    value={displayValues[key] || ""}
                    onChange={handleCurrencyChange(key)}
                    required
                    style={{ textAlign: "right", paddingRight: "5px" }}
                  />
                </div>
              ))}
            </>

            <div className="textbox">
                  <label htmlFor="quotationMsaDate">Quotation MSA Date</label>
                  <input
                    type="date"
                    id="quotationMsaDate"
                    value={quotationMsaDate}
                    onChange={(e) => setQuotationMsaDate(e.target.value)}
                    required
                    style={{ paddingLeft: "5px" }}
                  />
            </div>
          </div>
        </div>
        <input
          type="submit"
          className="btn-submit-order-input"
          value="Submit"
        />
      </form>
    </div>
  );
}

export default InputCompany;